var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-items-center"},[_c('gl-icon',{staticClass:"gl-ml-3 gl-mr-2",attrs:{"name":"infrastructure-registry"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.s__('InfrastructureRegistry|Terraform')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }